module.exports = __webpack_public_path__ + "img/userScale0.ed51813d.png";